// @flow
import type { Untranslated } from '@rover/shared/js/types';

export const isTranslatable = (obj: any) =>
  obj && (typeof obj === 'string' || typeof obj.id === 'string');

export const toUntranslated = (message: string): Untranslated => ({ id: message });

export const untranslatedToString = (obj: ?Untranslated): ?string =>
  obj && typeof obj === 'object' ? obj.id : obj;



// WEBPACK FOOTER //
// ../utilities/i18n.js